<template>
  <ion-row>
    <ion-col size-md="12" size-lg="12">
      <h3 class="h3 text-color-body">{{ t('signUp.emailTitle') }}</h3>
      <p class="text-color-body text-align-left text-sm">{{ t('signUp.emailDescription') }}</p>
      <div class="mt-lg">
        <CustomInput
          form-name="sign-up"
          type="text"
          :value="signUpForm.email"
          v-model="signUpForm.email"
          input-type="email"
          :label="t('login.labels.email')"
          name="email"
          class-name="custom-field"
          placeholder="name@domain.com"
          :icon="mailOutline"
        />
        <ion-row gutter="0">
          <ion-col size="12">
            <CustomInput
              :hide-clear="true"
              form-name="sign-up"
              :value="signUpForm.acceptTerms"
              v-model="signUpForm.acceptTerms"
              input-type="checkbox"
              :label="t('signUp.placeholders.acceptTerms')"
              name="acceptTerms"
            >
              <template #checkbox-label>
                <ion-label class="text-xs"
                  >{{ t('signUp.placeholders.acceptTerms') }}
                  <a href="https://www.lodgerin.com/public/terms" target="_blank">{{
                    t('signUp.placeholders.terms')
                  }}</a>
                </ion-label>
              </template>
            </CustomInput>
          </ion-col>
        </ion-row>
      </div>
    </ion-col>
  </ion-row>
</template>
<script setup lang="ts">
  import { mailOutline } from 'ionicons/icons';
  import { IonCol, IonLabel, IonRow } from '@ionic/vue';
  import { useI18n } from 'vue-i18n';
  import { useSignUp } from '@/composables/useSignUp';
  import CustomInput from '@/components/shared/form/CustomInput.vue';

  const { t } = useI18n();
  const { signUpForm } = useSignUp();

  // const toggleTerms = async () => {
  //   window.open('https://www.lodgerin.com/public/terms', '_blank');
  // };
</script>
<style scoped lang="scss"></style>
